export default {"src":"/_next/static/media/icon_list_clicked.cf9f94b2.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};